import { jflApi } from "../common/authApi";

// Device categories and the scheduling flag, on the JFL API.
//
// These go through jflApi - the signed-in session's cookies, with a 401
// refreshing the session - rather than the Basic keyId:rawKey header the
// service also accepts: that key is a server credential and must not ship in
// the browser bundle.

const errorMessage = (error, fallback) =>
  error.response?.data?.error?.errorMessage ||
  error.response?.data?.message ||
  error.message ||
  fallback;

// A category as a plain name, whether the service sends strings or objects.
const categoryName = (item) =>
  typeof item === "string"
    ? item.trim()
    : String(item?.name ?? item?.category ?? item?.label ?? "").trim();

// GET /v1/asset/categories -> category names.
export const fetchCategories = async () => {
  try {
    const response = await jflApi.get("/v1/asset/categories");
    const payload = response.data?.data;
    const list = Array.isArray(payload) ? payload : payload?.categories ?? [];
    return { success: true, data: list.map(categoryName).filter(Boolean) };
  } catch (error) {
    return { success: false, message: errorMessage(error, "Could not load device types") };
  }
};

// Sends all of `updates` to `path` in one call - the service takes any number
// of devices per request - and reports { deviceIds, success, message }. With
// nothing to send, no call is made.
const postUpdates = async (path, updates) => {
  const deviceIds = updates.map((update) => update.deviceId);
  if (deviceIds.length === 0) return { deviceIds, success: true };
  try {
    await jflApi.post(path, { updates });
    return { deviceIds, success: true };
  } catch (error) {
    return { deviceIds, success: false, message: errorMessage(error, "Could not save") };
  }
};

// POST /v1/asset/category  { updates: [{ deviceId, category }] }
export const saveCategories = (updates) => postUpdates("/v1/asset/category", updates);

// POST /v1/asset/scheduleConfig  { updates: [{ deviceId, scheduleConfig: { toBeScheduled } }] }
export const saveScheduleConfig = (updates) => postUpdates("/v1/asset/scheduleConfig", updates);
